import { services } from '../../core/feathers'
import { batch } from '../../modules/lib/batchReducer'
import { normalize } from 'normalizr'
import { schemas } from '../constants'
import { mergeEntities } from '../../modules/entities'

export default function configureItemListeners(dispatch, getState) {
  services.items.on('patched', item => {
    const { entities } = normalize(item, schemas.items)
    dispatch(batch('ITEM_PATCHED_EVENT', mergeEntities(entities)))
  })
}



// WEBPACK FOOTER //
// ./src/services/item/listeners.js